var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('HospitalHeader'),_c('div',{staticClass:"common-inner"},[_c('h2',{staticClass:"text-h4 text-center"},[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2),_c('ManagementFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }